import React from 'react';
import './ProjectShowcase.css';

interface Project {
  id: number;
  title: string;
  description: string;
  link: string;
  technologies: string[];
  imageUrl?: string;
}

const projects: Project[] = [
  {
    id: 1,
    title: "Mark Six",
    description: "A modern implementation of the Mark Six lottery game with interactive features and real-time updates.",
    link: "/mark-six",
    technologies: ["React", "TypeScript", "CSS3"],
    imageUrl: "/mark-six/preview.png"
  },
  {
    id: 2,
    title: "Fireworks",
    description: "An interactive fireworks display with beautiful animations and particle effects.",
    link: "/fireworks",
    technologies: ["JavaScript", "Canvas", "HTML5"],
    imageUrl: "/fireworks/preview.png"
  }
];

const ProjectShowcase: React.FC = () => {
  return (
    <div className="project-showcase">
      <h1>My Projects</h1>
      <div className="projects-grid">
        {projects.map((project) => (
          <div key={project.id} className="project-card">
            {project.imageUrl && (
              <div className="project-image">
                <img src={project.imageUrl} alt={project.title} />
              </div>
            )}
            <div className="project-content">
              <h2>{project.title}</h2>
              <p>{project.description}</p>
              <div className="technologies">
                {project.technologies.map((tech, index) => (
                  <span key={index} className="tech-tag">
                    {tech}
                  </span>
                ))}
              </div>
              <a
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                className="project-link"
              >
                View Project
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectShowcase; 